import { pushGroups } from "../../state/ducks";
import { dispatch } from "../../state/store";
import httpClient from "../httpClient";

const apiUrl = process.env.REACT_APP_API_URL;

const getRequestData = (endpoint) => {
  let url = `${apiUrl}/target-group-management/${endpoint}`;

  return url;
};

const fetchGroups = async () => {
  const url = getRequestData("get-target-groups");

  const { data } = await httpClient.get(url);
  dispatch(pushGroups(data));
  return data;
};

const createGroup = async (groupName, onPushGroupId) => {
  const url = getRequestData("create-target-group");

  let body = {
    name: groupName
  };

  const res = await httpClient.post(url, { data: body });

  if (res?.data?.id) {
    if (onPushGroupId) {
      onPushGroupId(res.data.id);
    }
    return res.data.id;
  }
};

const updateGroup = async (id, updatedName) => {
  const url = getRequestData("update-target-group");

  const body = {
    id: id,
    name: updatedName
  };

  return await httpClient.put(url, { data: body });
};

const deleteGroup = async (id) => {
  const url = getRequestData("delete-target-group");

  const body = {
    id: id
  };

  return await httpClient.remove(url, { data: body });
};

const getUserGroups = async ({ emails, isAdmin, targetGroupIds }) => {
  let url = getRequestData("get-target-group-user-assignments");
  const params = new URLSearchParams();

  if (emails && emails.length > 0) {
    params.append("email", emails.join(","));
    params.append("isAdmin", isAdmin ?? false);
  }

  if (targetGroupIds && targetGroupIds.length > 0) {
    params.append("targetGroupId", targetGroupIds.join(","));
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const { data } = await httpClient.get(url);

  return data;
};

const updateUserGroups = async ({ email, isAdmin, addedTargetGroups, removedTargetGroups }) => {
  const url = getRequestData("update-target-group-user-assignments");

  const body = {
    email,
    isAdmin,
    addedTargetGroups,
    removedTargetGroups
  };

  return await httpClient.post(url, { data: body });
};

const userGroupService = {
  fetchGroups,
  createGroup,
  updateGroup,
  deleteGroup,
  getUserGroups,
  updateUserGroups
};

export default userGroupService;
